<template>
  <el-drawer
    title="指派人员"
    :visible.sync="drawer"
    destroy-on-close
    :append-to-body="true"
    :wrapperClosable="false"
    :custom-class="sidebarIsOpen ? 'widthSpecial210' : 'widthSpecial54'"
  >
    <el-form ref="addForm" status-icon :model="addForm" label-width="83px" size="small" class="mx-20-4 bg-#fff py-20 pr-30" :rules="rules">
      <el-form-item label="执行人员：" prop="assignStaffName" label-width="93px">
        <el-select v-model="addForm.assignStaffName" style="width: 100%" clearable placeholder="选择执行人员" filterable value-key="assignStaffId">
          <el-option v-for="item in companyStaffLists" :key="item.id" :label="item.realName" :value="{ assignStaffId: item.id, assignStaffName: item.realName }">
            <span>{{ item.realName }}</span>
            <span v-if="!!item.staffStatus" class="staffStatus" :style="{ color: getstaffStatusType(item.staffStatus) }">
              ({{ dictType('staffStatusStatus', item.staffStatus) }})
            </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理期限：" prop="specifyFinishTime" style="margin-left: 10px">
        <el-date-picker v-model="addForm.specifyFinishTime" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间" />
      </el-form-item>
      <el-form-item label="难易度：" prop="difficulty" style="margin-left: 10px">
        <el-select v-model="addForm.difficulty" style="width: 100%" clearable placeholder="选择难易度" filterable>
          <el-option v-for="item in enumList.difficultyStatus" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="耗材：" prop="material" style="margin-left: 10px">
        <el-input v-angle="addForm.material" maxlength="30" style="width: 100%" show-word-limit v-model="addForm.material" type="text" placeholder="填写处理时需准备的耗材" />
      </el-form-item>

      <div class="form-Title mx-20-2">报修人信息</div>
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="所属项目：">
            {{ getCommunityName(previewForm.communityId) }}
          </el-form-item>
          <el-form-item label="报修人员：">
            {{ previewForm.submitUserName || '-' }}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房屋编号：">
            {{ previewForm.buildingRoomCode || '-' }}
          </el-form-item>
          <el-form-item label="联系方式：">
            {{ previewForm.submitUserPhone || '-' }}
          </el-form-item>
        </el-col>
      </el-row>

      <div class="form-Title mx-20-2">工单信息</div>
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="工单分类：">
            {{ previewForm.categoryName }}
          </el-form-item>
          <el-form-item label="紧急度：">
            <span
              :style="{
                color: getUrgentType(previewForm.urgentType, previewForm.state),
              }"
            >
              {{ dictType('urgentType', previewForm.urgentType) }}
            </span>
          </el-form-item>

          <el-form-item label="报修内容：" v-if="!!previewForm.content">{{ previewForm.content || '-' }}</el-form-item>
          <el-form-item label="报修语音：" v-if="!!previewForm.voiceUrl">
            <div style="display: flex">
              <div class="read-box" @click="getBo(previewForm.voiceUrl)">
                <img src="@/assets/image/bofang.png" alt="" style="width: 16px; height: 16px" />
                <span style="margin-left: 6px">播放语音</span>
              </div>
              <span style="margin-left: 4px; color: #9e9e9e; font-size: 14 px">{{ `${parseInt(previewForm.voiceDuration / 1000)}"` }}</span>
            </div>
          </el-form-item>
          <el-form-item label="照片：">
            <template v-if="previewForm.images">
              <ElImg v-for="(item, index) in previewForm.images.split(',')" :key="index" :src="item" />
            </template>
            <span v-else>无</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工单来源：">
            {{ dictType('distributeSource', previewForm.source) }}
          </el-form-item>
          <el-form-item label="预约时间：">
            {{ previewForm.appointmentTime || '-' }}
          </el-form-item>
          <el-form-item label="处理期限：">
            {{ handleNull(previewForm.specifyFinishTime) }}
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="previewForm.isAppraise === 1">
        <div class="form-Title">工单评价</div>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="评分：">
              {{ previewForm.appraiseScore || '-' }}
            </el-form-item>
            <el-form-item label="评价内容：">
              {{ previewForm.appraiseContent || '-' }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="评价时间：">
              {{ previewForm.appraiseTime || '-' }}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <div class="form-Title mx-20-2">工单流转</div>
      <el-table ref="multipleTable" row-key="id" :data="worksheetHandleRecordListArr" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
        <el-table-column label="序号" type="index" width="50" align="center" />
        <el-table-column label="操作类型" align="center">
          <template slot-scope="scope">
            {{ dictType('handleType', scope.row.handleType) }}
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center">
          <template slot-scope="scope">{{ scope.row.handleUserName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作备注" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.images">
              <ElImg v-for="(item, index) in scope.row.images.split(',')" :key="index" :src="item" />
            </template>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" align="center">
          <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
        </el-table-column>
      </el-table>
    </el-form>
    <FixedTwoButton :activeClass="sidebarIsOpen ? 'widthSpecial210' : 'widthSpecial54'">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { worksheetDoAssign, worksheetChargeUserList } from '@/api/workOrder'
import formatData from '@/utils/formatRequestData'
import { getImgUrl } from '@/api/getFile'
export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        assignStaffName: '',
        assignStaffId: '',
        worksheetId: '',
        material: '',
        specifyFinishTime: '',
        difficulty: '',
      },
      companyStaffLists: [],
      rules: {
        assignStaffName: [{ required: true, message: '执行人员不能为空', trigger: 'change' }],
      },
      dialogImgs: [],
      previewForm: {},
      worksheetHandleRecordListArr: [],
    }
  },
  watch: {
    drawer(val) {
      if (!val) return
      this.worksheetChargeUserList()
    },
  },
  methods: {
    getstaffStatusType(val1) {
      if (val1 === 1) return '#FF9002'
      if (val1 === 2) return '#31A8FF'
      if (val1 === 3) return '#cccccc'
    },
    getUrgentType(val1, val2) {
      if (val2 === 5) return ''
      if (val1 === 1) return '#EA0000'
      if (val1 === 2) return '#FF8F1F'
      if (val1 === 3) return '#00B578'
    },
    handleNull(e) {
      if (!e) {
        return '-'
      } else {
        return e.substring(0, 16)
      }
    },
    getBo(val) {
      let arr = this.originalImage(val)

      const audio = document.createElement('audio')
      audio.setAttribute('src', `${arr}`)
      audio.play()
    },
    originalImage(val) {
      return getImgUrl(val)
    },
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const { data: res } = await worksheetDoAssign(formatData(this.addForm))
      if (!res) return this.$message.error('指派失败')
      this.$message.success('指派成功')
      this.indexThis.$refs.Drawer.$refs.CardWorkList.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    async worksheetChargeUserList() {
      const { data: res } = await worksheetChargeUserList({ id: this.addForm.worksheetId })
      this.companyStaffLists = res || []
    },
  },
}
</script>

<style lang="scss" scoped>
.staffStatus {
  margin-left: 10px;
}
::v-deep .el-form-item__label {
  text-align: left !important;
}
::v-deep .el-form-item__label {
  text-align: left !important;
}
::v-deep .el-row {
  margin-bottom: 0px !important;
}
.read-box {
  width: 160px;
  height: 28px;
  border: 1px solid #3d3d3d;
  display: inline-block;
  text-align: center;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
